var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRanus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 16,
    viewBox: "0 0 72 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 6208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.704 5.85845V4.77699C12.704 3.64266 12.2579 2.55479 11.4637 1.7527C10.6696 0.95061 9.59245 0.5 8.46935 0.5H0V15.5H4.23467V2.66904H6.35806C6.91289 2.67215 7.44447 2.89448 7.83906 3.28843C8.23364 3.68239 8.45987 4.21669 8.46935 4.77699V5.85845C8.46935 6.42724 8.24564 6.97272 7.84742 7.37492C7.44921 7.77711 6.90912 8.00306 6.34596 8.00306H5.30544V10.1415H6.36411C6.92412 10.1464 7.45956 10.3745 7.85385 10.7761C8.24815 11.1778 8.46937 11.7205 8.46935 12.2862V15.5H12.704V12.2862C12.7105 11.6771 12.5881 11.0737 12.345 10.5163C12.1019 9.95883 11.7438 9.46029 11.2945 9.05397C11.7392 8.65176 12.0946 8.15914 12.3375 7.60842C12.5804 7.05771 12.7053 6.46134 12.704 5.85845Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.8118 0.5C17.6887 0.5 16.6116 0.95061 15.8175 1.7527C15.0233 2.55479 14.5771 3.64266 14.5771 4.77699V15.5H18.8118V10.1415H21.9939V8.00306H18.8118V4.77699C18.8118 4.20982 19.0349 3.66589 19.432 3.26484C19.8291 2.8638 20.3676 2.63849 20.9292 2.63849H23.0525V15.4694H27.2872V0.5H18.8118Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M33.3937 15.5V2.66904H35.5171C36.0734 2.66899 36.6074 2.89009 37.0036 3.28455C37.3999 3.67902 37.6264 4.21513 37.6344 4.77699V15.5H41.8691V4.77699C41.8691 3.64266 41.4229 2.55479 40.6288 1.7527C39.8346 0.95061 38.7575 0.5 37.6344 0.5H29.165V15.5H33.3937Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M52.2256 0.504578V13.3355H50.1022C49.5401 13.3355 49.0009 13.1104 48.6029 12.7096C48.2048 12.3087 47.9804 11.7648 47.9788 11.197V0.504578H43.7441V11.2215C43.7441 12.3558 44.1903 13.4437 44.9844 14.2458C45.7786 15.0479 46.8557 15.4985 47.9788 15.4985H56.4482V0.504578H52.2256Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M63.6388 2.65559H71.0616V0.510986H61.5033C60.6594 0.510986 59.85 0.849587 59.2533 1.4523C58.6565 2.05501 58.3213 2.87247 58.3213 3.72484V9.06496H66.7906V12.2788C66.7891 12.5582 66.6794 12.8259 66.4849 13.0245C66.2904 13.2232 66.0267 13.3372 65.7501 13.3419H58.3213V15.4865H67.8735C68.2916 15.4874 68.7057 15.4048 69.0922 15.2435C69.4786 15.0823 69.8297 14.8456 70.1253 14.547C70.421 14.2484 70.6553 13.8938 70.815 13.5035C70.9746 13.1133 71.0564 12.695 71.0556 12.2727V6.93869H62.5862V3.72484C62.5862 3.44231 62.6969 3.17126 62.8941 2.97092C63.0914 2.77057 63.3591 2.6572 63.6388 2.65559Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRanus);
export default __webpack_public_path__ + "static/media/Ranus.e9df9a84e249fbc14f274fdd0c0c9f3c.svg";
export { ForwardRef as ReactComponent };